import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { SETTINGS_PAGE_MAX_WIDTH } from 'src/constants/uiConsts';

import { SettingsPageRow } from './SettingsPageRow';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
  },
  main: {
    maxWidth: SETTINGS_PAGE_MAX_WIDTH,
    width: '100%',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: theme.spacing(4),
    width: '100%',
  },
  toolbarActionsWrapper: {
    width: 300,
    display: 'flex',
    justifyContent: 'right',
  },
}));

export const ModuleContainer: React.FC<{
  children?: React.ReactNode;
  description: React.ReactNode;
  toolbarActions?: React.ReactNode;
}> = ({ children, description, toolbarActions = null }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.main}>
        <SettingsPageRow
          fullHeight
          description={
            <div className={classes.header}>
              {description}
              <div className={classes.toolbarActionsWrapper}>
                {toolbarActions}
              </div>
            </div>
          }
        >
          {children}
        </SettingsPageRow>
      </div>
    </div>
  );
};
